import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import SecurityService from "services/SecurityService";
import es from 'locales/es'

i18n
    .use(initReactI18next)
    .init({
        lng: SecurityService.getUserLocale(),
        fallbackLng: "en",
        keySeparator: false,
        interpolation: { escapeValue: false },

        resources: {
            es: es
        },
    });
